var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27407_160893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.707646 11.846C0.960162 12.0702 1.35627 12.0459 1.58403 11.7972L10.2637 2.20833V7.79983C10.2637 8.1362 10.541 8.40919 10.8826 8.40919C11.2242 8.40919 11.5015 8.1362 11.5015 7.79983L11.4966 0.594738C11.4966 0.550864 11.4867 0.511865 11.4768 0.482616L11.3579 0.511865L11.4669 0.443617C11.4619 0.419242 11.457 0.394867 11.4421 0.365618C11.4272 0.336368 11.4124 0.311993 11.3975 0.297369L11.2985 0.370492L11.3728 0.263245C11.353 0.233996 11.3332 0.204746 11.3183 0.190122L11.2936 0.155998C11.2639 0.131624 11.2341 0.116999 11.2143 0.102374L11.1797 0.0828734C11.1648 0.0731243 11.1401 0.0584992 11.1104 0.043875C11.0361 0.0146248 10.9569 6.00807e-07 10.8826 5.94314e-07L4.08444 0C3.7428 -2.98672e-08 3.46553 0.272993 3.46553 0.609361C3.46553 0.945729 3.7428 1.21872 4.08444 1.21872L9.50118 1.21872L0.658132 10.988C0.430372 11.2366 0.450177 11.6217 0.707646 11.846Z",
    fill: "#57C22D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27407_160893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/ArrowGreen.e48ebe4554966bc08b11185fd12840b3.svg";
export { ForwardRef as ReactComponent };